<template>
  <div>
    <b-overlay
      id="overlay-background"
      blur="10px"
      opacity="0.30"
      rounded="sm"
      variant="light"
    >
      <div>
        <FilterCard :applied-filter-count="appliedFilterCount">
          <b-row>
            <b-col
              cols="12"
              md="3"
            >
              <b-form-group
                label="Deposit Date"
                label-for="v-ref-no"
              >
                <div class="position-relative">
                  <AdvancedDateFilter
                    :date-value="filters['branch_deposits.created_at']"
                    :opens="'right'"
                    @update="updateDateRange('branch_deposits.created_at', $event)"
                  />
                </div>
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              md="3"
            >
              <b-form-group
                label="Deposit ID"
                label-for="v-ref-no"
              >
                <b-form-input
                  id="v-ref-no"
                  v-model="filters['branch_deposits.ref_no']"
                  placeholder="Search"
                />
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              md="3"
            >
              <b-form-group
                label="Warehouse"
                label-for="arehouse"
              >
                <v-select
                  v-model="filters['app_warehouses.id']"
                  :options="warehouse"
                  :reduce="option => option.id"
                  label="name"
                  placeholder="Select Warehouse"
                >
                  <template v-slot:option="option">
                    {{ option.name }}
                  </template>
                </v-select>
              </b-form-group>
            </b-col>
          </b-row>
          <!-- Apply and Clear Filters -->
          <b-row class="mt-1">
            <b-col>
              <filter-buttons
                :filter-data="filters"
                :apply-filters="applyFilters"
                :clear-filters="clearFilters"
              />
            </b-col>
          </b-row>
        </FilterCard>
      </div>
      <div>
        <b-card
          no-body
        >
          <div
            class="m-2"
          >
            <b-row>
              <b-col
                class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
              >
                <div>
                  <ReportTableButtons
                    :items="items"
                    :json_fieldz="json_fields"
                    :name="`${downloadReportName} - Page ${page}.xls`"
                    :bulkname="`${downloadReportName}.xls`"
                    :fetch="fetchBranchProgressNoPagination"
                    @refresh="fetchBranchProgress"
                  />
                </div>
              </b-col>
            </b-row>
          </div>
          <b-table
            striped
            hover
            responsive
            :per-page="perPage"
            :items="items"
            :fields="fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            show-empty
            sticky-header="100vh"
            @sort-changed="sortChanged"
          >
            <template #empty>
              <TableDataFetching
                :rows="items"
                :data-loading="dataLoading"
              />
            </template>
            <template #head()="{ field }">
              <div
                class="sortable-header"
              >
                <span class="header-text">{{ field.label }}</span>
                <feather-icon
                  v-if="field.sortable"
                  :icon="sort === field.key
                    ? 'ArrowUpIcon'
                    : 'ArrowDownIcon'"
                  size="14"
                />
              </div>
            </template>
            <template #cell(deposit_date)="data">
              {{ __dateTimeFormatter(data.value) }}
            </template>
            <template #cell(order_count)="data">
              {{ __numberWithCommas(data.value) }}
            </template>
            <template #cell(total_delivery_charge)="data">
              {{ __numberWithCommas(data.value, true) }}
            </template>
            <template #cell(warehouse_type)="data">
              <b-badge :variant="`${data.value === 1 ? 'light-success' : 'light-primary'}`">
                {{ data.value === 1 ? 'Agent' : 'Branch' }}
              </b-badge>
            </template>
          </b-table>
          <div class="mx-2 mb-2">
            <b-row>
              <b-col
                cols="12"
                md="3"
                class="d-flex align-items-center justify-content-sm-start"
              >
                <label class="mr-1">Per page</label>
                <v-select
                  v-model="perPage"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="pageOptions"
                  :clearable="false"
                  class="per-page-selector d-inline-block ml-1 width-100"
                />
              </b-col>
              <!-- Pagination -->
              <b-col
                cols="12"
                md="9"
                class="d-flex align-items-center justify-content-sm-end"
              >
                <span class="text-muted pagination-text  mt-1 mt-md-0 mr-1">Showing {{ meta.from }} to {{ meta.to }} of {{ meta.total }} entries</span>
                <b-pagination
                  v-model="page"
                  :total-rows="(meta.total)? meta.total : 0"
                  :per-page="perPage"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
                >
                  <template #prev-text>
                    <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                    />
                  </template>
                </b-pagination>

              </b-col>
            </b-row>
          </div>
        </b-card>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCard,
  BCol,
  BFormGroup,
  BFormInput,
  BRow,
  BTable,
  VBModal,
  BOverlay,
  BPagination,
  VBTooltip,
  BBadge,

} from 'bootstrap-vue'
import Filter from '@core/mixins/filter'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import vSelect from 'vue-select'
import AdvancedDateFilter from '@/components/AdvancedDateFilter/AdvancedDateFilter.vue'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import Ripple from 'vue-ripple-directive'
import FilterButtons from '@/components/Filter/ReportFilterButtons.vue'
import tableMixin from '@core/mixins/tableMixin'
import FilterCard from '@/components/FilterCard/FilterCard.vue'

const ReportRepository = RepositoryFactory.get('report')
const ResourceRepository = RepositoryFactory.get('resource')

export default {
  directives: {
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
    Ripple,
  },
  components: {
    FilterCard,
    vSelect,
    AdvancedDateFilter,
    BCard,
    BTable,
    BRow,
    BCol,
    BFormGroup,
    BOverlay,
    BPagination,
    BFormInput,
    BBadge,
    FilterButtons,
  },
  mixins: [Filter, SuccessMessage, ErrorMessage, tableMixin],
  data() {
    return {
      filters: {
        'branch_deposits.created_at': {
          startDate: null,
          endDate: null,
        },
      },
      tableData: [],
      dataLoading: false,
      sort: '',
      perPage: 20,
      pageOptions: [10, 20, 50, 100, 200],
      totalRows: 1,
      page: 1,
      meta: {},
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      warehouse: [],
      fields: [
        {
          key: 'deposit_date',
          label: 'Deposit Date',
          thClass: 'text-left',
          tdClass: 'text-left',
          sortable: true,
        },
        {
          key: 'deposit_id',
          label: 'Deposit ID',
          thClass: 'text-left',
          tdClass: 'text-left',
        },
        {
          key: 'warehouse_name',
          label: 'Warehouse',
          thClass: 'text-left',
          tdClass: 'text-left',
        },
        {
          key: 'ref_no',
          label: 'Ref No',
          thClass: 'text-left',
          tdClass: 'text-left',
          sortable: true,
        },
        {
          key: 'warehouse_type',
          label: 'Type',
          thClass: 'text-left',
          tdClass: 'text-left',
        },
        {
          key: 'order_count',
          label: 'Order Count',
          thClass: 'text-right',
          tdClass: 'text-right',
          sortable: true,
        },
        {
          key: 'total_delivery_charge',
          label: 'Delivery Charge',
          thClass: 'text-right',
          tdClass: 'text-right',
          sortable: true,
        },
      ],
      json_fields: {
        'DEPOSIT DATE': {
          field: 'deposit_date',
          // eslint-disable-next-line no-underscore-dangle
          callback: value => this.__dateTimeFormatter(value),
        },
        'DEPOSIT ID': {
          field: 'deposit_id',
          callback: value => `"${value}"`,
        },
        WAREHOUSE: {
          field: 'warehouse_name',
          callback: value => `"${value}"`,
        },
        'REF NO': {
          field: 'ref_no',
          callback: value => `"${value}"`,
        },
        TYPE: {
          field: 'warehouse_type',
          callback: value => (value === 1 ? 'Agent' : 'Branch'),
        },
        'ORDER COUNT': {
          field: 'order_count',
          callback: value => `"${value}"`,
        },
        'DELIVERY CHARGE': {
          field: 'total_delivery_charge',
          callback: value => `"${value}"`,
        },
      },
      currentDate: '',
      todayFilterQuery: '',
      downloadReportName: 'Branch-Progress-Report',
      items: [],
      expenseOptions: [],
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
  },
  watch: {
    options: {
      handler() {
        this.fetchBranchProgress()
      },
    },
    deep: true,
    page() {
      this.fetchBranchProgress()
    },
    perPage() {
      this.fetchBranchProgress()
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length
    this.setTodayFilter()
    this.fetchBranchProgress()
    this.readDataforWarehouse()
    this.updateFilterCount()
  },
  methods: {
    async fetchBranchProgress() {
      this.dataLoading = true
      this.items = []
      const filterQuery = this.buildFilterQuery()
      try {
        const { data } = (await ReportRepository.getBranchProgressReport(this.page, filterQuery, this.perPage))
        // fiter the default date or selected date for table data and meta data
        this.items = data.data
        this.meta = data.meta
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.dataLoading = false
    },
    async fetchBranchProgressNoPagination() {
      try {
        const filterQuery = this.buildFilterQuery()
        const { data } = (await ReportRepository.getBranchProgressReportNoPagiantion(filterQuery))
        return data.data
      } catch (e) {
        this.convertAndNotifyError(e)
        return []
      }
    },
    async readDataforWarehouse() {
      try {
        const { data } = (await ResourceRepository.getBranchListDropdown()).data
        this.warehouse = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    handleChangePage(page) {
      this.page = page
      this.fetchBranchProgress()
    },
    setTodayFilter() {
      const currentDate = this.todayFilter()
      this.updateDateRange('branch_deposits.created_at', currentDate)
    },
    applyFilters() {
      this.fetchBranchProgress()
      this.updateFilterCount()
    },
    clearFilters() {
      this.filters = {
        'branch_deposits.created_at': {
          startDate: null,
          endDate: null,
        },
      }
      this.setTodayFilter()
      this.$nextTick(() => {
        this.fetchBranchProgress()
      })
      this.updateFilterCount()
    },
  },
}
</script>
<style lang="scss">
@import '../../../@core/scss/vue/libs/vue-select';
</style>
